import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Wrapper, Header, CellContainer, GridColumn } from './styled';
import StatusCell from '../../status-cell';
import getTopicCellSummary from './get-topic-cell-summary';

const CollapsedGrid = ({ activities, topicId, i18n }) => {
  const assignments = useSelector(
    (state) => state.CourseAssignReducer.assignments
  );

  const sortedStudents = useSelector(
    (state) => state.CourseAssignReducer.sortedStudents
  );

  const datePreference = useSelector((state) =>
    state.CourseAssignReducer?.datePreference?.length > 0
      ? state.CourseAssignReducer?.datePreference
      : [undefined, undefined]
  );

  const courseId = useSelector(
    (state) => state.CourseAssignReducer.activeCourseID
  );

  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );
  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);
  const instructionHubBlockedLookup = useSelector(
    (state) => state.CourseAssignReducer.instructionHubBlockedLookup
  );
  return (
    <Wrapper>
      <Header />
      <GridColumn>
        {sortedStudents.map((sortedStudent) => {
          const { encryptedUserProfileId } = sortedStudent;
          const studentCells = assignments.studentAssignments.filter(
            (student) =>
              student.encryptedUserProfileId === encryptedUserProfileId
          );

          return (
            <CellContainer key={encryptedUserProfileId}>
              <StatusCell
                i18n={i18n}
                activities={activities}
                topicId={topicId}
                key={encryptedUserProfileId}
                studentInfo={studentCells[0]}
                currentStudent={sortedStudent}
                {...getTopicCellSummary(
                  studentCells,
                  activities,
                  instructionHubBlockedLookup
                )}
                isCollapsed
                datePreference={datePreference}
                courseId={courseId}
                classroomId={classroomId}
                groupId={groupId}
              />
            </CellContainer>
          );
        })}
      </GridColumn>
    </Wrapper>
  );
};

CollapsedGrid.propTypes = {
  activities: PropTypes.array,
  topicId: PropTypes.number.isRequired,
  i18n: PropTypes.object
};

CollapsedGrid.defaultProps = {
  activityIds: []
};

export default CollapsedGrid;



// WEBPACK FOOTER //
// ./components/grid/collapsed/index.js